const allowedExtensions = [
  ".pdf",
  ".doc",
  ".docx",
  ".txt",
  ".rtf",
  ".odt",
  ".xls",
  ".xlsx",
  ".xlsm",
  ".csv",
  ".ods",
  ".ppt",
  ".pptx",
  ".odp",
  ".jpg",
  ".jpeg",
  ".png",
  ".gif",
  ".webp",
  ".bmp",
  ".svg",
  ".tif",
  ".tiff",
  ".mp3",
  ".wav",
  ".ogg",
  ".m4a",
  ".mp4",
  ".mov",
  ".avi",
  ".mkv",
  ".webm",
  ".html",
  ".css",
  ".js",
  ".ts",
  ".tsx",
  ".json",
  ".xml",
  ".yaml",
  ".yml",
  ".md",
  ".epub",
  ".ico",
  ".icns",
  ".html",
  ".txt",
];

export const getAllowedFileExtensions = () => {
  return allowedExtensions.join(",");
};
